import { render, staticRenderFns } from "./BtnViewDinamico.vue?vue&type=template&id=521b7b16&scoped=true"
import script from "./BtnViewDinamico.vue?vue&type=script&lang=js"
export * from "./BtnViewDinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b7b16",
  null
  
)

export default component.exports